import { ValuationNumberFormat } from '@dealstack/shared/lib/generated';

const numberFormatToFactor: Record<ValuationNumberFormat, number> = {
	[ValuationNumberFormat.UNFORMATTED]: 1,
	[ValuationNumberFormat.THOUSANDS]: 1_000,
	[ValuationNumberFormat.MILLIONS]: 1_000_000,
	[ValuationNumberFormat.BILLIONS]: 1_000_000_000,
};

export function getNumberFactor(format: ValuationNumberFormat | undefined): number {
	return numberFormatToFactor[format ?? ValuationNumberFormat.UNFORMATTED];
}
